import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@components/Dialog";
import { Image } from "@components/Image";
import { Typography } from "@components/Typography";

import { ICON_PATHS } from "@configs/icons";

interface VerificationRequiredDialogProps {
	onClose: () => void;
	onNavigate: () => void;
}

export const VerificationRequiredDialog = ({ onClose, onNavigate }: VerificationRequiredDialogProps) => {
	const onClick = () => {
		onNavigate();
		onClose();
	};

	return (
		<Dialog open onOpenChange={onClose}>
			<DialogContent className="max-w-100 pb-6">
				<DialogHeader className="flex flex-row items-center gap-2.5">
					<Image src={ICON_PATHS.AGE_VERIFICATION} alt="ageVerificationIcon" />
					<DialogTitle>Verify your age</DialogTitle>
				</DialogHeader>

				<Typography type="span" className="flex items-center gap-1" size="sm">
					Complete{" "}
					<Typography color="primary" size="sm" onClick={onClick} className="cursor-pointer hover:opacity-60">
						Age Verification
					</Typography>{" "}
					to go live
				</Typography>
			</DialogContent>
		</Dialog>
	);
};
